/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Box } from '@mui/material';
import type { SxProps } from '@mui/system/styleFunctionSx';
import type { ReactNode } from 'react';

export function ToggleableSection( { isVisible, children, sx }: { isVisible: boolean; children: ReactNode; sx?: SxProps } ): ReactNode {
	return (
		<Box
			sx={ {
				visibility: isVisible ? 'visible' : 'hidden',
				transition: theme => theme.transitions.create( 'all', {
					duration: theme.transitions.duration.shorter
				} ),
				...sx
			} }
		>
			{ children }
		</Box>
	);
}
